<template>
  <div>
    <!-- Pinned (on the Dashboard) the tab row already names it and it can't be closed -->
    <div v-if="!pinned" class="sticky top-0 z-10 flex items-center justify-between py-2 mb-1 bg-surface-raised dark:bg-surface-raised-dark">
      <h3 class="text-base font-semibold text-fg-base dark:text-fg-base-dark">{{ teacher ? 'Scheduling' : 'Lesson Signups' }}</h3>
      <button @click="$emit('close')" class="p-1 text-fg-faint dark:text-fg-faint-dark rounded transition-colors" aria-label="Close">
        <XMarkIcon class="h-5 w-5" />
      </button>
    </div>
    <!-- Excused streaks + break follow-ups: every teacher's, whichever list they get below -->
    <StudentCheckIns />
    <TeacherSignupsTab v-if="teacher" />
    <LessonSignupsTab v-else :is-admin="isAdmin" />
  </div>
</template>

<script setup>
// The signups list, for WorkspaceSidebar.vue. Staff with signups access get the
// full list; teachers (`teacher`) only the signups connected to them, in a tab named Scheduling.
import { XMarkIcon } from '@heroicons/vue/24/outline'
import LessonSignupsTab from '../tabs/LessonSignupsTab.vue'
import TeacherSignupsTab from '../tabs/TeacherSignupsTab.vue'
import StudentCheckIns from '../common/StudentCheckIns.vue'

defineProps({
  isAdmin: { type: Boolean, default: false },
  teacher: { type: Boolean, default: false },
  pinned:  { type: Boolean, default: false },
})
defineEmits(['close'])
</script>
